import React, { useEffect } from "react";
import { useTransferModel } from "./transferModel";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { YhBox } from "@/components/YhBox";
import { TransferDataTable } from "./DataTable";

export const TransferDataBox = () => {
    const {
        state,
        dataSource,
        selectedRowKeys,
        loadData,
        setSelectedData,
    } = useTransferModel();

    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [state])
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "测试",
            value: "123",
            color: DescriptionColorEnum.green
        },
        {
            label: "测试2",
            value: "33.233",
            color: DescriptionColorEnum.red
        }
    ]


    return (
        <>
            <YhBox title={"转账记录"}>
                <TransferDataTable />
            </YhBox>
        </>
    )
}
